import { render, staticRenderFns } from "./pagesetting.vue?vue&type=template&id=6e9c1f1e&scoped=true"
import script from "./pagesetting.vue?vue&type=script&lang=js"
export * from "./pagesetting.vue?vue&type=script&lang=js"
import style0 from "./pagesetting.vue?vue&type=style&index=0&id=6e9c1f1e&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c1f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9c1f1e')) {
      api.createRecord('6e9c1f1e', component.options)
    } else {
      api.reload('6e9c1f1e', component.options)
    }
    module.hot.accept("./pagesetting.vue?vue&type=template&id=6e9c1f1e&scoped=true", function () {
      api.rerender('6e9c1f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/pagesetting.vue"
export default component.exports